module.exports = __webpack_public_path__ + "img/img2.e7abc92f.png";